import { GeneroEnum } from "../models/enums/GeneroEnum";

export const GeneroLabelMap: Record<GeneroEnum, string> = {
  [GeneroEnum.Acao]: "Ação",
  [GeneroEnum.Romance]: "Romance",
  [GeneroEnum.Comedia]: "Comédia",
  [GeneroEnum.Terror]: "Terror",
  [GeneroEnum.Aventura]: "Aventura",
  [GeneroEnum.Drama]: "Drama",
  [GeneroEnum.Suspense]: "Suspense",
  [GeneroEnum.FiccaoCientifica]: "Ficção Científica",
  [GeneroEnum.Fantasia]: "Fantasia",
  [GeneroEnum.Animacao]: "Animação",
  [GeneroEnum.Documentario]: "Documentário",
  [GeneroEnum.Musical]: "Musical",
  [GeneroEnum.Guerra]: "Guerra",
  [GeneroEnum.Faroeste]: "Faroeste",
  [GeneroEnum.Misterio]: "Mistério",
};

export const generoLabel = (genero: number): string => {
  return GeneroLabelMap[genero as GeneroEnum] ?? "Desconhecido";
};